<template>
  <div class="warning-bubble flex flex-align-center">
    <p class="mr-3">{{ icon }}</p>
    <p>{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'WarningBubble',
  props: {
    icon: {
      type: String,
      required: false,
      default: '⚠️',
    },
    message: {
      type: String,
      required: true,
      default: '',
    },
  },
};
</script>

<style scoped>
.warning-bubble {
  padding: 10px 12px 11px 12px;
  border-radius: 10px;
  border: solid 1px #dcdccf;
  background-color: #fffef8;

  p {
    font-size: 14px;
  }
}
</style>
